<!-- 公司图片 -->
<template>
    <div v-if="componentsData.type == 11" :style="`padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;`">
        <div class="swiper-container" v-if="companyData.show_pic.length"
            :style="`border-radius: ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px;`"
        >
            <Carousel v-if="componentsData.content.autoplay == 1" radius-dot dots="inside" >
                <CarouselItem v-for="(item, index) of companyData.show_pic" :key="index" class="h260">
                    <img class="wh100" :src="item"
                        :style="componentsData.content.version ?
                            `border-radius: ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px;` :
                            `border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px;`
                        "                    
                    />
                </CarouselItem>
            </Carousel>
            <div v-else>
                <imgStyle class="h100" :imageData="componentsData" :imgList="companyData.show_pic" ></imgStyle>
            </div>
        </div>
        <div class="none-div" v-else>请上传公司图片~</div>
    </div>
</template>

<script>
import imgStyle from "@/components/imgStyle/imgStyle.vue";
export default {
    components: {
        imgStyle,
    },
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
        companyData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.swiper-container {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    z-index: 1;
}
.h100 {
    height: 100%;
}
.wh100 {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.none-div {
    font-size: 14px;
    color: #808080;
}
.h260 {
    height: 260px;
}
</style>